import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import PivotGrid, {
    IPivotGridOptions,
    Export,
} from 'devextreme-react/pivot-grid';
import dxPivotGrid from "devextreme/ui/pivot_grid";
import dxChart from "devextreme/viz/chart";
import Chart, { CommonSeriesSettings, Size, Tooltip, AdaptiveLayout } from 'devextreme-react/chart';
import ExporterToExcel from '../utils/ExporterToExcel';
import { ObjectUtils } from '../utils/ObjectUtils';


export interface IReportPivotGridOptions extends IPivotGridOptions {
    reportName?: any;
    runDate?: any;
    showChart?: boolean;
    innerRef?: any;
    chartInnerRef?: any;
}


const ReportPivot: React.FC<PropsWithChildren<IReportPivotGridOptions>> = ({ reportName, showChart, runDate, ...props }) => {
    const [formDataPrepared, setFormDataPrepared] = useState(false);

    let chartRef = props.chartInnerRef || useRef(null);
    let pivotRef = props.innerRef || useRef(null);
    const pivotInstance = (): dxPivotGrid => {
        let pivot = pivotRef.current;
        if (pivot) {
            let instance: dxPivotGrid | null = pivot.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }
    const chartInstance = (): dxChart => {
        let chart = chartRef.current;
        if (chart) {
            let instance: dxChart | null = chart.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }

    const bindPivotWithChart = () => {
        if (!showChart) return;
        pivotInstance().bindChart(chartInstance(), {
            dataFieldsDisplayMode: 'splitPanes',
            alternateDataFields: false,
        });
    }

    const fetchCallbackReportItem = async () => {
        setFormDataPrepared(true);
        bindPivotWithChart();
    }// it's OK
    useEffect(
        () => {
            fetchCallbackReportItem();
        }
        ,
        []
    );
    const onExporting = React.useCallback((e) => {
        ExporterToExcel.exportToExcel(reportName, [e.component]);
        e.cancel = true;
    },
        []
    );

    ObjectUtils.evalAllProperty(props, props, false, 1, 4);

    return (
        <div className="report-pivot-container">
                {showChart &&
                    <Chart
                        className="report-pivot-chart"
                        ref={chartRef}
                    >
                        <Tooltip enabled={true} />
                        <CommonSeriesSettings type="bar" />
                        <AdaptiveLayout width={450} />
                    </Chart>
                }
                <PivotGrid
                    ref={pivotRef}
                    onExporting={onExporting}
                    className="report-pivot"
                {...props}
            >
                    <Export
                        enabled={false}                        
                    />
                {props.children}
            </PivotGrid>
        </div>
        );

}


export default React.memo(ReportPivot);

//<Size height={200} />
